/*!
 * @license
 * Alfresco Example Content Application
 *
 * Copyright (C) 2005 - 2020 Alfresco Software Limited
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail.  Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with Alfresco. If not, see <http://www.gnu.org/licenses/>.
 */

import { RuleContext } from '@alfresco/adf-extensions';
import { GROUP_ADMINISTRATION_SITE_MANAGER, GROUP_RECORDS_SITE, GROUP_TRANSFERS_SITE, GROUP_TRANSFER_CALENDAR_SITE, GROUP_LOANS_SITE, UDEU_RECORD_TYPE, UDEU_TRANSFER_TYPE, UDEU_LOANS_TYPE, UDEU_TRANSFER_CALENDAR_TYPE, GROUP_BOUD_SITE, UDEU_NOTIFICATION_EMAIL_PROP, UDEU_BOUD_TYPE, GROUP_OPERADOR } from '../model/contants/deusto';
import { AcaRuleContext, canCopyNode, canDeleteSelection, canDownloadSelection, canEditAspects, canEditFolder, canManagePermissions } from '@alfresco/aca-shared/rules';
import { canManageFolderRules } from 'projects/aca-folder-rules/src/lib/folder-rules.rules';
import { hasPropertyValue, isInGroup, isNotType, isViewer } from 'projects/alden-extension/src/lib/rules/alden.rules';
import { NodeEntry, Person } from '@alfresco/js-api';

/* MODULES */
export const canBoud = (context: RuleContext): boolean => { 
  return isInGroup(context.profile, GROUP_BOUD_SITE);
};

export const canLoans = (context: RuleContext): boolean => { 
  return isInGroup(context.profile, GROUP_LOANS_SITE);
};

export const canTransferCalendar = (context: RuleContext): boolean => { 
  return isInGroup(context.profile, GROUP_TRANSFER_CALENDAR_SITE);
};

export const canTransfers = (context: RuleContext): boolean => { 
  return isInGroup(context.profile, GROUP_TRANSFERS_SITE);
};

export const canRecords = (context: RuleContext): boolean => { 
  return isInGroup(context.profile, GROUP_RECORDS_SITE);
};

export const canAdministration = (context: RuleContext): boolean => {  
  return isInGroup(context.profile, GROUP_ADMINISTRATION_SITE_MANAGER);
};


/* CONTEXT MENU AND TOOLBAR ACTIONS */
function isNotModuleType(context: RuleContext): boolean {
  return isNotType(context.selection.nodes, UDEU_RECORD_TYPE) 
  && isNotType(context.selection.nodes, UDEU_TRANSFER_TYPE)
  && isNotType(context.selection.nodes, UDEU_TRANSFER_CALENDAR_TYPE)
  && isNotType(context.selection.nodes, UDEU_LOANS_TYPE)
  && isNotType(context.selection.nodes, UDEU_BOUD_TYPE)
}

export function canAddFavorite(context: RuleContext): boolean {
  if(isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canDownloadSelectionUdeu(context: RuleContext): boolean {
  if(canDownloadSelection(context) && isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canEditFolderUdeu(context: RuleContext): boolean {
  if(canEditFolder(context) && isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canCopyNodeUdeu(context: RuleContext): boolean {
  if(canCopyNode(context) && isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canDeleteSelectionUdeu(context: RuleContext): boolean {
  if(canDeleteSelection(context) && isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canEditAspectsUdeu(context: RuleContext): boolean {
  if(canEditAspects(context) && isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canManagePermissionsUdeu(context: RuleContext): boolean {
  if(canManagePermissions(context) && isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canManageFolderRulesUdeu(context: AcaRuleContext): boolean {
  if(canManageFolderRules(context) && isNotModuleType(context)) {
    return true;
  } 
  return false; 
}

export function canExcelExport(context: RuleContext): boolean {
  const { url } = context.navigation;
  const group = "GROUP_site_" + url.replace('/viewer/', '') + '_SiteManager';
  return isViewer(context) && (isInGroup(context.profile,GROUP_OPERADOR) || isInGroup(context.profile, group));
  //return false;
}

export function isMyElement(node: NodeEntry, personDetails: Person) {
  if(personDetails?.capabilities.isAdmin 
    || hasPropertyValue(node, UDEU_NOTIFICATION_EMAIL_PROP, personDetails?.email?.trim()) 
    || hasPropertyValue(node, UDEU_NOTIFICATION_EMAIL_PROP, personDetails?.firstName?.trim())) {
    return true;
  }
  return false;
}